import { render, staticRenderFns } from "./TenderDocumentAdd.vue?vue&type=template&id=083cf4c6&scoped=true"
import script from "./TenderDocumentAdd.vue?vue&type=script&lang=js"
export * from "./TenderDocumentAdd.vue?vue&type=script&lang=js"
import style0 from "./TenderDocumentAdd.vue?vue&type=style&index=0&id=083cf4c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083cf4c6",
  null
  
)

export default component.exports